/* Hortelã 2.0 · calculadora de frete da página do produto.
   Valor e prazo saem da mesma tabela fixa por faixa de CEP e peso usada na finalização da compra
   (snippets/h2-frete-tabela.liquid). O nome da cidade vem do ViaCEP só pra exibir; sem ele a conta funciona igual. */
(function () {
  'use strict';

  var CHAVE = 'h2-cep';
  var CAMPOS_DO_JORDAO = [12460000, 12489999];
  var tabela = null;
  var cidades = {};

  function lerTabela() {
    if (tabela) return tabela;
    var el = document.getElementById('h2-frete-tabela');
    try { tabela = JSON.parse(el ? el.textContent : '{}') || {}; } catch (e) { tabela = {}; }
    if (!tabela.f) tabela.f = [];
    return tabela;
  }

  /* Valor e prazo pra um CEP (8 números) e um peso em gramas.
     Se o CEP cair em duas faixas, vale a de prazo maior. Sem linha na tabela, devolve null. */
  function cotar(cep, gramas) {
    var n = parseInt(cep, 10), g = Math.max(0, Math.ceil(gramas || 0)), f = lerTabela().f, melhor = null;
    for (var i = 0; i < f.length; i++) {
      if (n < f[i][0] || n > f[i][1]) continue;
      var bandas = f[i][3] || [];
      for (var j = 0; j < bandas.length; j++) {
        var b = bandas[j];
        if (g < b[0] || g > b[1]) continue;
        if (!melhor || b[3] > melhor.dias || (b[3] === melhor.dias && b[2] > melhor.valor)) {
          melhor = { uf: f[i][2], valor: b[2], dias: b[3] };
        }
      }
    }
    return melhor;
  }

  function soNumeros(v) { return String(v || '').replace(/\D/g, '').slice(0, 8); }
  function comHifen(n) { return n.length > 5 ? n.slice(0, 5) + '-' + n.slice(5) : n; }
  function reais(centavos) {
    var n = (Math.round(centavos) / 100).toFixed(2).split('.');
    return 'R$ ' + n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + n[1];
  }
  function esc(t) {
    return String(t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function diasUteis(d) { return d === 1 ? '1 dia útil' : d + ' dias úteis'; }

  function lembrar(dados) { try { localStorage.setItem(CHAVE, JSON.stringify(dados)); } catch (e) {} }
  function lembrado() {
    try {
      var d = JSON.parse(localStorage.getItem(CHAVE) || 'null');
      return d && /^\d{8}$/.test(d.cep) ? d : null;
    } catch (e) { return null; }
  }

  function comPrazo(promessa, ms) {
    return new Promise(function (ok, falha) {
      var t = setTimeout(function () { falha(new Error('tempo')); }, ms);
      promessa.then(function (v) { clearTimeout(t); ok(v); }, function (e) { clearTimeout(t); falha(e); });
    });
  }

  function buscarCidade(cep) {
    if (Object.prototype.hasOwnProperty.call(cidades, cep)) return Promise.resolve(cidades[cep]);
    if (!window.fetch) return Promise.resolve(null);
    var ctrl = window.AbortController ? new AbortController() : null;
    var pedido = fetch('https://viacep.com.br/ws/' + cep + '/json/', ctrl ? { signal: ctrl.signal } : undefined)
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
      .then(function (d) { return d && !d.erro && d.localidade ? { cidade: d.localidade, uf: d.uf || '' } : null; });
    return comPrazo(pedido, 2000).then(
      function (c) { cidades[cep] = c; return c; },
      function () { if (ctrl) ctrl.abort(); return null; }
    );
  }

  function buscarSacola() {
    if (!window.fetch) return Promise.resolve(null);
    var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var pedido = fetch(raiz + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); });
    return comPrazo(pedido, 2500).catch(function () { return null; });
  }

  function montar(caixa) {
    var form = caixa.querySelector('[data-h2-frete-form]');
    var campo = caixa.querySelector('[data-h2-frete-cep]');
    var botao = caixa.querySelector('[data-h2-frete-botao]');
    var aviso = caixa.querySelector('[data-h2-frete-erro]');
    var saida = caixa.querySelector('[data-h2-frete-resultado]');
    if (!form || !campo || !saida) return;

    var minimo = parseInt(caixa.getAttribute('data-frete-minimo'), 10) || 0;
    var zap = caixa.getAttribute('data-zap') || '';
    var lojas = caixa.getAttribute('data-lojas') || '';
    var produto = caixa.getAttribute('data-produto') || '';
    var inicial = caixa.getAttribute('data-variante') || '';
    var variantes = {};
    try { variantes = JSON.parse((caixa.querySelector('[data-h2-frete-variantes]') || {}).textContent || '{}'); } catch (e) {}
    var secao = caixa.closest('.product__item-js') || caixa.closest('.shopify-section') || document;
    var atual = { cep: '', local: null, sacola: null, quando: 0, assinatura: '', vez: 0 };

    function formProduto() {
      return secao.querySelector('form[id^="product-form-"]') || document.querySelector('form[id^="product-form-"]');
    }
    function variacao() {
      var f = formProduto(), el = f ? f.querySelector('[name="id"]') : null;
      var id = el && el.value ? String(el.value) : '';
      if (!variantes[id]) {
        var m = window.location.search.match(/[?&]variant=(\d+)/);
        id = m && variantes[m[1]] ? m[1] : inicial;
      }
      return id;
    }
    function quantidade() {
      var f = formProduto(), el = null;
      if (f) el = f.querySelector('[name="quantity"]') || (f.id ? document.querySelector('[name="quantity"][form="' + f.id + '"]') : null);
      var q = el ? parseInt(el.value, 10) : 1;
      return q > 0 && q < 1000 ? q : 1;
    }
    function assinatura() { return variacao() + '|' + quantidade(); }

    /* Peso e valor do pedido: esta peça na quantidade escolhida, mais o que já está na sacola.
       Se esta mesma cor e tamanho já estiver na sacola, vale a sacola como está (não conta duas vezes). */
    function pedido() {
      var id = variacao(), v = variantes[id] || [0, 0], q = quantidade();
      var r = { gramas: v[0] * q, centavos: v[1] * q, sacola: '' };
      var s = atual.sacola;
      if (s && s.item_count > 0) {
        var subtotal = typeof s.items_subtotal_price === 'number' ? s.items_subtotal_price : (s.total_price || 0);
        var jaTem = (s.items || []).some(function (it) { return String(it.variant_id) === id; });
        r.gramas = (jaTem ? 0 : r.gramas) + (s.total_weight || 0);
        r.centavos = (jaTem ? 0 : r.centavos) + subtotal;
        r.sacola = jaTem ? 'Com o que já está na sua sacola' : 'Somando com a sua sacola';
      }
      return r;
    }

    function ehCampos(cep, local) {
      if (local && local.cidade) return /^campos do jord[aã]o$/i.test(local.cidade.trim());
      var n = parseInt(cep, 10);
      return n >= CAMPOS_DO_JORDAO[0] && n <= CAMPOS_DO_JORDAO[1];
    }

    function linkZap(cep) {
      if (!zap) return '';
      var texto = 'Oi! Quero saber o frete pro CEP ' + comHifen(cep) + (produto ? ', da peça ' + produto : '') + '.';
      return 'https://wa.me/' + zap + '?text=' + encodeURIComponent(texto);
    }

    function opcao(nome, valor, detalhe, gratis) {
      return '<li class="h2-frete__opcao">' +
        '<span class="h2-frete__nome">' + nome + '</span>' +
        '<span class="h2-frete__valor' + (gratis ? ' h2-frete__valor--gratis' : '') + '">' + valor + '</span>' +
        '<span class="h2-frete__prazo">' + detalhe + '</span>' +
        '</li>';
    }

    function desenhar() {
      var cep = atual.cep, local = atual.local, p = pedido(), cot = cotar(cep, p.gramas);
      var h = [], itens = [];
      h.push(local && local.cidade
        ? '<p class="h2-frete__destino">Pra <strong>' + esc(local.cidade) + (local.uf ? ' - ' + esc(local.uf) : '') + '</strong></p>'
        : '<p class="h2-frete__destino">Pro CEP <strong>' + comHifen(cep) + '</strong></p>');

      if (ehCampos(cep, local)) {
        itens.push(opcao('Retirar na loja', 'Grátis',
          'Numa das nossas lojas' + (lojas ? ' · <a href="' + esc(lojas) + '">ver endereços</a>' : ''), true));
      }
      var gratis = !!cot && minimo > 0 && p.centavos >= minimo;
      if (cot) {
        itens.push(opcao('Entrega padrão',
          gratis ? '<s>' + reais(cot.valor) + '</s> Grátis' : reais(cot.valor),
          'Chega em até ' + diasUteis(cot.dias) + ' depois da postagem', gratis));
      }
      if (itens.length) h.push('<ul class="h2-frete__opcoes">' + itens.join('') + '</ul>');

      if (cot) {
        if (minimo > 0) {
          if (gratis) {
            h.push('<p class="h2-frete__gratis"><strong>Frete grátis:</strong> ' +
              (p.sacola ? p.sacola.toLowerCase() + ', a compra passa de ' : 'essa compra passa de ') + reais(minimo) + '.</p>');
          } else {
            h.push('<p class="h2-frete__gratis">' + (p.sacola ? p.sacola + ', faltam ' : 'Faltam ') +
              '<strong>' + reais(minimo - p.centavos) + '</strong> pro frete grátis.</p>');
          }
        }
        h.push('<p class="h2-frete__nota">Postamos em até 1 dia útil depois da confirmação do pagamento.' +
          (cot.dias > 7 ? ' Quer mais rápido? O Sedex aparece na finalização da compra.' : '') + '</p>');
      } else {
        h.push('<p class="h2-frete__sem">Não consegui calcular a entrega pra esse CEP aqui. Chama a gente no WhatsApp que a gente te passa o valor e o prazo.</p>');
        var z = linkZap(cep);
        if (z) h.push('<a class="h2-frete__zap" href="' + esc(z) + '" target="_blank" rel="noopener">Chamar no WhatsApp</a>');
      }
      saida.innerHTML = h.join('');
      atual.assinatura = assinatura();
    }

    function mostrarErro(msg) {
      if (aviso) { aviso.textContent = msg; aviso.hidden = !msg; }
      if (msg) campo.setAttribute('aria-invalid', 'true'); else campo.removeAttribute('aria-invalid');
    }
    function carregando(sim) {
      if (botao) { botao.disabled = sim; botao.textContent = sim ? 'Calculando…' : 'Calcular'; }
      saida.setAttribute('aria-busy', sim ? 'true' : 'false');
    }

    function calcular(cep) {
      var vez = ++atual.vez, salvo = lembrado();
      mostrarErro('');
      carregando(true);
      var pCidade = salvo && salvo.cep === cep && salvo.cidade
        ? Promise.resolve({ cidade: salvo.cidade, uf: salvo.uf || '' })
        : buscarCidade(cep);
      var pSacola = !atual.sacola || Date.now() - atual.quando > 20000 ? buscarSacola() : Promise.resolve(atual.sacola);
      Promise.all([pCidade, pSacola]).then(function (r) {
        if (vez !== atual.vez) return;
        atual.cep = cep;
        atual.local = r[0];
        if (r[1]) { atual.sacola = r[1]; atual.quando = Date.now(); }
        carregando(false);
        desenhar();
        lembrar({ cep: cep, cidade: r[0] ? r[0].cidade : '', uf: r[0] ? r[0].uf : '' });
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var cep = soNumeros(campo.value);
      if (cep.length !== 8) { mostrarErro('Digite os 8 números do CEP.'); campo.focus(); return; }
      calcular(cep);
    });

    campo.addEventListener('input', function () {
      var n = soNumeros(campo.value), m = comHifen(n);
      if (campo.value !== m) campo.value = m;
      if (n.length === 8) {
        mostrarErro('');
        if (n !== atual.cep) calcular(n);
      }
    });

    /* Trocou cor, tamanho ou quantidade: refaz a conta com o mesmo CEP */
    function talvezRefazer() {
      if (atual.cep && saida.firstChild && assinatura() !== atual.assinatura) desenhar();
    }
    document.addEventListener('change', function (e) {
      var alvo = e.target;
      if (!alvo || caixa.contains(alvo)) return;
      if (secao === document || secao.contains(alvo)) setTimeout(talvezRefazer, 120);
    });
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(talvezRefazer, 80); });
    }
    setInterval(talvezRefazer, 900);

    var salvo = lembrado();
    if (salvo) {
      campo.value = comHifen(salvo.cep);
      calcular(salvo.cep);
    }
  }

  function iniciar() {
    var caixas = document.querySelectorAll('[data-h2-frete]');
    for (var i = 0; i < caixas.length; i++) {
      if (caixas[i].getAttribute('data-h2-frete-pronto')) continue;
      caixas[i].setAttribute('data-h2-frete-pronto', '1');
      montar(caixas[i]);
    }
  }

  window.H2Frete = { cotar: cotar };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
